/* ============================================================
   ICHII — shared behaviors
   ドロワー / ヒーロー自動スクロール / カラーカルーセル /
   商品バリアント選択 / ギャラリー入れ替え
   ============================================================ */

(function () {
  'use strict';

  function initIchii() {
  /* ---------- drawer ---------- */

  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    if(btn.dataset.ichiiReady) return; btn.dataset.ichiiReady='1';
    btn.addEventListener('click', function () {
      var d = document.querySelector('[data-drawer]');
      if (d) d.classList.add('is-open');
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    if(el.dataset.ichiiReady) return; el.dataset.ichiiReady='1';
    el.addEventListener('click', function () {
      var d = document.querySelector('[data-drawer]');
      if (d) d.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = document.querySelector('[data-drawer]');
      if (d) d.classList.remove('is-open');
    }
  });

  /* ---------- hero marquee: duplicate track group ---------- */

  document.querySelectorAll('[data-hero-track]').forEach(function (track) {
    if(track.dataset.ichiiReadydata_hero_track) return; track.dataset.ichiiReadydata_hero_track='1';
    var group = track.querySelector('[data-hero-group]');
    if (!group) return;
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  /* ---------- color carousel ---------- */

  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    if(root.dataset.ichiiReadydata_carousel) return; root.dataset.ichiiReadydata_carousel='1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var nameEl = root.querySelector('[data-carousel-name]');
    if (!slides.length) return;
    var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (nameEl) nameEl.textContent = slides[i].getAttribute('data-color-name') || '';
    }

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    show(i);
  });

  /* ---------- product gallery: サムネを押すとメイン画像が変わる ---------- */

  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    if(root.dataset.ichiiReadydata_gallery) return; root.dataset.ichiiReadydata_gallery='1';
    var main = root.querySelector('[data-gallery-main] img') || root.querySelector('img[data-gallery-main]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (!img) return;
        var detail = root.querySelector('[data-gallery-detail]');
        var target = detail || main;
        if (detail) { detail.hidden = false; root.querySelector('.product__set-card').hidden = true; }
        target.src = btn.getAttribute('data-full') || img.currentSrc || img.src;
        target.removeAttribute('srcset');
        target.alt = img.alt || btn.getAttribute('aria-label') || '商品の着用写真';
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
  });

  /* ---------- product variant picker ---------- */

  document.querySelectorAll('[data-product]').forEach(function (root) {
    if(root.dataset.ichiiReadydata_product) return; root.dataset.ichiiReadydata_product='1';
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var state = {};
    root.querySelectorAll('[data-opt-value].is-active').forEach(function (b) {
      state[b.getAttribute('data-opt-name')] = b.getAttribute('data-opt-value');
    });

    /* URLの ?color=／?variant=（色名のとき）で初期色を上書きする。
       押した写真の色のまま開くための入口（プレビュー用。Shopify本番の ?variant=数値 はサーバー側で解釈済み） */
    var colorParam = /[?&](?:color|variant)=([^&#]+)/i.exec(location.search);
    var colorOverridden = false;
    if (colorParam && !/^\d+$/.test(colorParam[1])) {
      var wantColor = decodeURIComponent(colorParam[1]).toUpperCase();
      var colorAlias = { BLACK: 'KURO', WHITE: 'IVORY', SHIRO: 'IVORY' };
      wantColor = colorAlias[wantColor] || wantColor;
      var wantBtn = root.querySelector('[data-opt-value="' + wantColor + '"]');
      if (wantBtn && state[wantBtn.getAttribute('data-opt-name')] !== wantColor) {
        state[wantBtn.getAttribute('data-opt-name')] = wantColor;
        colorOverridden = true;
      }
    }

    function currentVariant() {
      return variants.find(function (v) {
        return Object.keys(state).every(function (k) { return v.options[k] === state[k]; });
      });
    }

    function render(skipImage) {
      root.querySelectorAll('[data-opt-value]').forEach(function (b) {
        var k = b.getAttribute('data-opt-name');
        b.classList.toggle('is-active', state[k] === b.getAttribute('data-opt-value'));
      });
      Object.keys(state).forEach(function (k) {
        var lab = root.querySelector('[data-opt-label="' + k + '"]');
        if (lab) lab.textContent = state[k];
      });
      var v = currentVariant();
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var btn = root.querySelector('[data-add-to-cart]');
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
        }
        var selectedColor = state['Color'] || state['color'] || state['カラー'];
        /* 曲線の枠（相手商品の切り抜き＋写真4枚）を選択中の色に合わせる */
        updateStory(selectedColor);
        var detailSources = document.getElementById('ichii-detail-sources');
        if (detailSources) {
          try {
            var sources = JSON.parse(detailSources.textContent);
            var colorDetails = sources[selectedColor];
            if (colorDetails) document.querySelectorAll('[data-ichii-story-detail]').forEach(function(img) {
              img.src = colorDetails[img.getAttribute('data-ichii-story-detail')];
            });
          } catch(e) { /* Keep the server-rendered product image. */ }
        }
        /* SETはTOPS/PANTSの2枚を1つのカードとして、選択中の色に合わせる */
        if (setMediaMap) {
          updateSetMedia(selectedColor);
        /* 単品商品は、色ごとのバリアント画像があればメイン画像を差し替える */
        } else if (!skipImage && v.image) {
          var main = root.querySelector('[data-gallery-main] img') || root.querySelector('img[data-gallery-main]');
          if (main && main.getAttribute('src') !== v.image) {
            main.src = v.image;
            main.removeAttribute('srcset');
          }
        }
      }
    }

    var setMediaEl = root.querySelector('[data-set-media-json]');
    var setMediaMap = null;
    try { setMediaMap = setMediaEl ? JSON.parse(setMediaEl.textContent) : null; } catch (e) { setMediaMap = null; }
    function updateSetMedia(color) {
      if (!setMediaMap || !color) return;
      var images = setMediaMap[color];
      if (!images) {
        var up = String(color).toUpperCase();
        var alias = { BLACK: 'KURO', IVORY: 'SHIRO', WHITE: 'SHIRO' };
        images = setMediaMap[alias[up]] || setMediaMap[up];
      }
      if (!images) return;
      var detail = root.querySelector('[data-gallery-detail]');
      if (detail) { detail.hidden = true; root.querySelector('.product__set-card').hidden = false; }
      ['top', 'pants'].forEach(function (kind) {
        var img = root.querySelector('[data-set-media="' + kind + '"]');
        if (img && images[kind] && img.getAttribute('src') !== images[kind]) {
          img.src = images[kind];
          img.removeAttribute('srcset');
        }
      });
    }

    var storyEl = root.querySelector('[data-story-json]');
    var storyMap = null;
    try { storyMap = storyEl ? JSON.parse(storyEl.textContent) : null; } catch (e) { storyMap = null; }
    function updateStory(color) {
      if (!storyMap || !color) return;
      var set = storyMap[color];
      if (!set) {
        var up = String(color).toUpperCase();
        var alias = { BLACK: 'KURO', SHIRO: 'IVORY', WHITE: 'IVORY' };
        set = storyMap[alias[up]] || storyMap[up];
      }
      if (!set) return;
      Object.keys(set).forEach(function (key) {
        if (/_href$/.test(key)) {   /* 相手商品へのリンク＝選んでいる色の同色バリアント（t_href / a_href） */
          var link = root.querySelector('[data-shot="' + key.replace(/_href$/, '') + '"]');
          if (link && link.tagName === 'A') link.setAttribute('href', set[key]);
          return;
        }
        if (/_full$/.test(key)) {   /* 自分の商品の枠: 押した時のメイン画像（高解像度） */
          var th = root.querySelector('[data-shot="' + key.replace(/_full$/, '') + '"]');
          if (th && th.hasAttribute('data-full')) th.setAttribute('data-full', set[key]);
          return;
        }
        var el = root.querySelector('[data-shot="' + key + '"]');
        if (!el) return;
        var img = el.querySelector('img');
        if (img && img.getAttribute('src') !== set[key]) { img.src = set[key]; img.removeAttribute('srcset'); }
        if (el.hasAttribute('data-full') && key !== 't' && key !== 'a') el.setAttribute('data-full', set[key]);
      });
    }

    root.querySelectorAll('[data-opt-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        state[b.getAttribute('data-opt-name')] = b.getAttribute('data-opt-value');
        render();
      });
    });

    /* URLで色を上書きした時は、スウォッチをクリックした時と同じ経路でメイン画像まで差し替える */
    render(!colorOverridden);
  });
  }
  initIchii();
  document.addEventListener("shopify:section:load", initIchii);
})();

/* ---------- ころもちゃんカーソル ----------
   html[data-cursor="on"] のとき、DOM要素(.koromo)をポインタに追従させる。大きさは常に100%＝横128px。
   リンク・ボタンの上に来たら0.2秒かけて50%に縮み、外れたら0.2秒で100%に戻る。
   CSSの cursor:url() は大きさをアニメできない（差し替えは一瞬）ので要素で描く。タッチ端末（pointer:coarse）では出さない。 */
(function () {
  var R = document.documentElement;
  var CUR_D = "M589.8 612.5C584.1 611.0 573.0 605.9 568.8 602.9C563.7 599.2 560.0 593.2 560.0 588.6C560.0 584.1 561.2 581.6 568.0 570.5C573.7 561.4 578.7 549.5 580.1 541.7C581.8 532.7 579.6 525.5 573.0 518.6C568.4 513.8 564.6 511.3 544.0 499.5C539.3 496.9 531.8 491.9 527.3 488.4C511.9 476.7 500.7 476.0 495.2 486.5C492.0 492.7 493.8 504.8 500.2 519.4C507.8 536.9 503.8 552.5 488.6 563.7C478.1 571.6 461.3 578.7 443.0 582.9C403.2 592.3 309.2 592.3 244.6 582.9C220.2 579.4 206.7 573.2 198.9 562.0C189.6 548.7 189.8 530.8 199.6 503.3C202.0 496.4 204.0 489.4 204.0 487.8C204.0 479.8 196.2 472.4 180.4 465.4C175.5 463.3 166.2 458.9 159.8 455.7C149.4 450.6 147.8 449.4 145.5 445.5C143.7 442.5 142.7 439.1 142.3 434.3C140.7 413.7 155.9 388.3 179.0 373.4C195.4 362.9 205.2 359.7 247.7 351.0C302.9 339.7 330.0 333.1 330.0 331.1C330.0 329.4 326.6 329.0 305.2 328.0C260.8 326.0 250.7 324.9 225.0 319.5C187.4 311.5 175.8 310.5 94.6 308.9C32.2 307.7 32.5 307.7 21.5 300.5C11.2 293.6 3.1 280.8 1.0 267.9C-0.4 258.8 -0.2 236.7 1.4 229.0C2.9 222.0 10.2 202.5 14.4 194.2C18.0 187.0 25.8 179.7 33.7 175.9C42.7 171.6 51.4 171.2 87.6 173.5C130.8 176.2 149.5 175.1 182.9 167.5C246.1 153.1 239.6 154.0 291.0 153.0C336.8 152.2 350.2 151.0 363.7 146.9C370.9 144.6 376.0 140.6 376.0 137.0C376.0 133.1 372.1 129.2 361.7 122.3C332.4 103.2 326.0 93.6 326.0 69.1C326.1 42.4 333.7 28.3 353.3 19.0C364.1 13.8 373.2 11.6 398.0 8.0C437.7 2.4 468.2 0.0 502.5 0.0C551.4 -0.0 581.3 5.5 594.3 17.0C599.8 21.8 601.0 24.7 601.0 33.7C601.0 48.9 595.8 62.4 587.0 70.3C584.4 72.6 578.1 77.0 573.0 80.0C561.7 86.6 557.4 90.6 556.0 96.2C554.7 100.8 555.4 108.0 557.5 112.1C561.0 118.7 570.5 124.3 584.3 127.9C604.4 133.1 627.2 134.7 694.6 135.5C721.0 135.8 746.3 136.5 750.7 137.0C764.7 138.6 798.2 149.0 825.0 160.2C833.0 163.5 843.1 167.5 847.5 169.0C859.0 173.0 863.1 174.9 878.1 183.3C911.8 202.1 922.7 207.5 937.1 212.3C960.3 220.0 973.2 233.4 979.1 255.7C983.0 270.4 981.9 293.4 976.7 303.5C970.3 316.1 957.1 324.6 934.9 330.4C910.0 336.8 885.9 338.4 825.9 337.7C762.2 336.8 738.4 338.4 726.3 344.1C721.1 346.6 719.7 348.3 719.7 352.0C719.7 356.4 724.3 362.2 733.4 369.2C746.7 379.5 748.0 381.1 748.0 386.4C748.0 395.2 743.4 402.2 735.0 406.5C732.5 407.8 725.5 410.3 719.5 412.0C700.3 417.6 694.3 421.4 693.3 428.8C691.8 440.2 707.2 454.3 738.0 469.9C758.7 480.4 763.5 481.5 792.5 483.0C823.6 484.6 839.4 488.1 850.9 496.1C857.4 500.5 859.5 503.6 859.4 508.8C859.2 518.4 849.6 526.6 820.0 542.5C756.0 576.9 692.9 598.5 620.5 611.1C602.0 614.3 597.0 614.5 589.8 612.5Z", CUR_W = 982, CUR_H = 614;
  var HOT = 'a, button, [role="button"], input, select, textarea, label, summary, [data-opt-value], .p-shot';
  var el = null, live = false, onMove, onOver, onOut;
  function start() {
    if (live) return;
    if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
    live = true;
    el = document.createElement('div'); el.className = 'koromo'; el.setAttribute('aria-hidden', 'true');
    var img = document.createElement('div'); img.className = 'koromo__img';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + CUR_W + ' ' + CUR_H + '"><path fill="#000" fill-rule="evenodd" d="' + CUR_D + '"/></svg>';
    img.style.backgroundImage = 'url("data:image/svg+xml;base64,' + btoa(svg) + '")';
    el.appendChild(img);
    document.body.appendChild(el);
    onMove = function (e) {
      el.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
      el.classList.add('is-on');
    };
    onOver = function (e) {
      var t = e.target && e.target.closest ? e.target.closest(HOT) : null;
      el.classList.toggle('is-small', !!t);
    };
    onOut = function (e) { if (!e.relatedTarget) el.classList.remove('is-on'); };   /* 窓の外へ出たら隠す */
    document.addEventListener('mousemove', onMove, { passive: true });
    document.addEventListener('mouseover', onOver, { passive: true });
    document.addEventListener('mouseout', onOut, { passive: true });
    R.setAttribute('data-cursor-live', 'on');
  }
  function stop() {
    if (!live) return;
    live = false;
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseover', onOver);
    document.removeEventListener('mouseout', onOut);
    if (el && el.parentNode) el.parentNode.removeChild(el);
    el = null;
    R.removeAttribute('data-cursor-live');
  }
  function sync() { if (R.getAttribute('data-cursor') === 'on') start(); else stop(); }
  sync();
  if (window.MutationObserver) new MutationObserver(sync).observe(R, { attributes: true, attributeFilter: ['data-cursor'] });
})();

/* Keep removal on the same native quantity-update path as the cart form. */
document.querySelectorAll('[data-cart-remove]').forEach(function(link){
  link.addEventListener('click',function(event){
    var row=link.closest('tr');
    var input=row && row.querySelector('input[name="updates[]"]');
    var form=link.closest('form');
    var update=form && form.querySelector('button[name="update"]');
    if(!input || !form || !update || !form.requestSubmit) return;
    event.preventDefault();
    input.value='0';
    form.requestSubmit(update);
  });
});
